<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-snackbar v-model="meetingLocationAddedNotif" auto-height top>
			{{ meetingLocationAddedNotifText }}
			<v-btn color="pink" flat @click="meetingLocationAddedNotif = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">Reschedule Review</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>

				<v-card-text>
					<v-layout row wrap>
						<v-flex sm6>
							<v-menu
								ref="scheduledDateUTCMenu"
								v-model="form.scheduledDateUTC.menu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="form.scheduledDateUTC.date"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<v-text-field slot="activator" v-model="scheduledDateFormatted" prepend-icon="date_range" label="Scheduled Date" readonly :error-messages="scheduledDateUTCErrors"></v-text-field>
								<v-date-picker v-model="form.scheduledDateUTC.date" @input="$refs.scheduledDateUTCMenu.save(form.scheduledDateUTC.date)"> </v-date-picker>
							</v-menu>
						</v-flex>

						<v-flex sm6>
							<v-dialog ref="scheduledTimeMenu" v-model="form.scheduledTime.menu" :return-value.sync="form.scheduledTime.time" persistent lazy full-width width="290px">
								<template v-slot:activator="{ on }">
									<v-text-field v-model="form.scheduledTime.time" label="Scheduled Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
								</template>
								<v-time-picker v-if="form.scheduledTime.menu" v-model="form.scheduledTime.time" full-width>
									<v-spacer></v-spacer>
									<v-btn flat color="primary" @click="form.scheduledTime.menu = false">Cancel</v-btn>
									<v-btn flat color="primary" @click="$refs.scheduledTimeMenu.save(form.scheduledTime.time)">OK</v-btn>
								</v-time-picker>
							</v-dialog>
						</v-flex>
					</v-layout>

					<v-select v-model="form.meetingLocation" clearable prepend-icon="location_on" :items="meetingLocations" label="Meeting Location" item-text="name" item-value="id" return-object required> </v-select>
					<div class="text-xs-left" style="margin-top:-12px; margin-left: 20px;">
						<v-btn flat small color="primary" @click="onAddMeetingLocation">Add new</v-btn>
					</div>

					<v-switch prepend-icon="date_range" v-model="form.sendMeetingRequests" label="Send updated calendar invites" :hint="calendarInvitesNotificationText" persistent-hint></v-switch>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit" :disabled="isSaving" :loading="isSaving">Save <span slot="loader">Saving...</span></v-btn>
				</v-card-actions>
			</v-form>
		</v-card>

		<meeting-location-editor :dialog="meetingLocationEditorDialog" title="Add New Meeting Location" @save="saveMeetingLocation" @closeEditor="meetingLocationEditorDialog = false"> </meeting-location-editor>
	</v-dialog>
</template>

<script>
	import moment from 'moment';
	import { validationMixin } from 'vuelidate';
	import { required, email } from 'vuelidate/lib/validators';
	import MeetingLocationEditor from '@/components/settings/MeetingLocationEditor';

	export default {
		props: {
			dialog: {
				required: true
			},
			performanceReview: {
				type: Object,
				required: true
			},
			meetingLocations: {
				type: Array,
				required: true
			},
			isSaving: {
				type: Boolean,
				required: false
			}
		},
		components: {
			MeetingLocationEditor
		},
		data() {
			return {
				form: {
					id: this.performanceReview.id,
					scheduledDateUTC: {
						date: this.$options.filters.formatDate(this.performanceReview.scheduledDateUTC, 'YYYY-MM-DD'),
						menu: false
					},
					scheduledTime: {
						time: this.$options.filters.formatDate(this.performanceReview.scheduledDateUTC, 'HH:mm'),
						menu: false
					},
					meetingLocation: this.performanceReview.meetingLocation,
					sendMeetingRequests: true
				},
				meetingLocationEditorDialog: false,
				meetingLocationAddedNotifText: null,
				meetingLocationAddedNotif: false
			};
		},
		methods: {
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			submit() {
				this.$v.form.$touch();

				let scheduledDateUTC = moment(`${this.form.scheduledDateUTC.date} ${this.form.scheduledTime.time}`, 'YYYY-MM-DD HH:mm');

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id,
						scheduledDateUTC: scheduledDateUTC,
						meetingLocation: this.form.meetingLocation,
						scheduledDateTimeSpecified: this.form.scheduledTime.time != null,
						sendMeetingRequests: this.form.sendMeetingRequests
					};
					this.$emit('save', postObj);
				}
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					id: null,
					scheduledDateUTC: {
						date: null,
						menu: false
					},
					scheduledTime: {
						time: null,
						menu: false
					},
					meetingLocation: null
				};
			},
			onAddMeetingLocation() {
				this.meetingLocationEditorDialog = true;
			},
			saveMeetingLocation(meetingLocation) {
				this.$store
					.dispatch('meetingLocations/add', meetingLocation)
					.then(
						response => {
							this.meetingLocationAddedNotifText = 'New Meeting Location added';
							this.form.meetingLocation = response.data;
						},
						error => {
							this.meetingLocationAddedNotifText = 'Failed to add Meeting Location';
							console.error('Error saving Meeting Location');
						}
					)
					.finally(() => {
						this.meetingLocationAddedNotif = true;
					});
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				scheduledDateUTC: { date: { required } }
			}
		},
		computed: {
			scheduledDateUTCErrors() {
				const errors = [];
				if (!this.$v.form.scheduledDateUTC.date.$dirty) return errors;
				!this.$v.form.scheduledDateUTC.date.required && errors.push('Scheduled Date is required.');
				return errors;
			},
			scheduledDateFormatted() {
				return this.$options.filters.formatDate(this.form.scheduledDateUTC.date);
			},
			scheduledDateUtcFormatted() {
				return moment(`${this.form.scheduledDateUTC.date} ${this.form.scheduledTime.time}`, 'YYYY-MM-DD HH:mm');
			},
			calendarInvitesNotificationText() {
				let result = `This will send out calendar invites for a meeting on `;
				if(this.form.scheduledTime.time != null) 
					return result += `${this.$options.filters.formatDateTime(this.scheduledDateUtcFormatted)}`; 
				else {
					return result += `${this.$options.filters.formatDate(this.scheduledDateUtcFormatted)}`;
				}
			},
		}
	};
</script>

<style></style>
